import React from 'react'

import { number } from 'prop-types'

function CarouselProgress({ currentSlide }) {
  return (
    <div className="carousel-progress">
      <div className="carousel-progress__dots">
        {Array.from({ length: 8 }).map((_, index) => (
          <div
            key={index}
            className={`carousel-progress__dot ${
              index === currentSlide ? 'carousel-progress__dot--active' : ''
            }`}
          />
        ))}
      </div>
    </div>
  )
}

CarouselProgress.propTypes = {
  currentSlide: number.isRequired,
}

export default CarouselProgress
